/**
 * @generated SignedSource<<b005febfdc4f80d68a93a78f554e1933>>
 * @relayHash 9ad4b70bfe6d3405a8b9228e9257483a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc2fb0537b71e6bd661005f739db2580b36c3b26e072c9a5cb5456b4a9250141

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bc2fb0537b71e6bd661005f739db2580b36c3b26e072c9a5cb5456b4a9250141",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
